import render from './render'

export default {
  name: 'Buttons',

  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  render
}
